exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  margin-top: 30px;\n}\n\n.title {\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n}\n\n.new-simulation-button {\n  float: right;\n}\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/sources/sources.component.css
// module id = ../../../../../src/app/components/sources/sources.component.css
// module chunks = main